// extracted by mini-css-extract-plugin
module.exports = {"ChatMessagePane":"ChatMessagePane_ChatMessagePane__ipGS1"};